module.exports = __webpack_public_path__ + "static/media/example-2.386ba55f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BunburyCentral/example-2.jpg
// module id = 283
// module chunks = 0